import { Menu, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { LanguageSelector, useI18n } from "../i18n";
import { Brand } from "./Brand";

export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { messages } = useI18n();
  const navItems = [
    { label: messages.nav.water, href: "/#water" },
    { label: messages.nav.journey, href: "/#journey" },
    { label: messages.nav.journal, href: "/journal" }
  ] as const;

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search, location.hash, location.key]);

  return (
    <header className="site-header">
      <div className="site-header__inner shell">
        <Brand />
        <nav className="site-nav" aria-label={messages.nav.primaryLabel}>
          {navItems.map((item) => (
            <Link key={item.href} to={item.href}>
              {item.label}
            </Link>
          ))}
        </nav>
        <div className="header-actions">
          <LanguageSelector />
          <Link className="button button--small header-cta" to="/#interest">
            {messages.nav.join}
          </Link>
        </div>
        <button
          className="menu-button"
          type="button"
          aria-label={menuOpen ? messages.nav.close : messages.nav.open}
          aria-expanded={menuOpen}
          aria-controls="mobile-navigation"
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
        </button>
      </div>
      {menuOpen ? (
        <nav
          id="mobile-navigation"
          className="mobile-nav"
          aria-label={messages.nav.mobileLabel}
        >
          {navItems.map((item) => (
            <Link key={item.href} to={item.href}>
              {item.label}
            </Link>
          ))}
          <Link className="button" to="/#interest">
            {messages.nav.join}
          </Link>
        </nav>
      ) : null}
    </header>
  );
}
